import { STORE_NAME } from '@neyara/shared';
import { Link } from 'react-router';
import { Lotus } from '../components/lotus';

export function NotFoundPage() {
  return (
    <section className="tissue grid min-h-[70svh] place-items-center px-6 py-20 text-center">
      <title>{`Page not found - ${STORE_NAME}`}</title>
      <div>
        <Lotus className="mx-auto h-12 w-20 text-gold-deep" />
        <h1 className="mt-6 font-script text-4xl text-maroon italic sm:text-5xl">This page has slipped off the shelf.</h1>
        <p className="mt-4 text-ink-soft">The link may be old, or the saree may no longer be listed.</p>
        <Link to="/sarees" className="btn btn-maroon mt-9">
          Browse the sarees
        </Link>
      </div>
    </section>
  );
}
